<template>
	<div class="h-100">
		<div class="container h-100">
			<div class="row h-100 justify-content-center align-items-center">
				<div class="col-lg-6">
					<img
						src="/assets/img/abdom-logo.png"
						class="img-fluid mb-4 mx-auto d-block"
						style="max-width: 300px">
					<div class="card text-center">
						<div class="card-body">
							<form class="form-signin">
								<h1>Forgot Password</h1>
								<p class="text-muted">
									Enter your email address below and we'll send you a password reset link.
								</p>
								<div class="clearfix mb-4"></div>
								<div class="form-group">
									<label for="email">Email address</label>
									<input
										id="email"
										type="email"
										class="form-control"
										placeholder="Email address"
										required
										autofocus
										:value="email"
										@input="email = $event.target.value">
								</div>
								<div
									v-if="api_error"
									class="alert alert-danger">
									{{ api_error }}
								</div>
								<button
									class="btn btn-lg btn-primary btn-block"
									@click.prevent="submit">
									Submit
								</button>
								<div class="clearfix mt-2"></div>
								<div class="text-center text-muted">
									<a href="/login">Login</a>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ForgotPassword',
		components: {},
		data () {
			return {
				email: '',
				api_error: ''
			}
		},
		mounted () {
		},
		methods: {
			submit: function () {
				this.api_error = '';
				this.$axios.post('/api/forgot-password', {
					email: this.email
				}).then(() => {
					toastr.success('Please check your emails.');
				}).catch(error => {
					this.api_error = error.response.data.message
				})

			}
		}
	}
</script>

<style lang="scss" scoped>
	body {
		background: white;
	}

	label {
		color: #B0BAC9;
		text-transform: uppercase;
		font-size: 0.75em;
	}

	#app .content {
		margin-top: 0 !important;
	}

	.form-signin {
		width: 100%;
		max-width: 330px;
		padding: 15px;
		margin: auto;
	}

	.form-signin .checkbox {
		font-weight: 400;
	}

	.form-signin .form-control {
		position: relative;
		box-sizing: border-box;
		height: auto;
		padding: 10px;
		font-size: 16px;
	}

	.form-signin .form-control:focus {
		z-index: 2;
	}

	.form-signin input[type="email"] {
		margin-bottom: -1px;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
	}

	.form-signin input[type="password"] {
		margin-bottom: 10px;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}
</style>
